import { ModuleWithProviders, NgModule } from '@angular/core';
import { CbreHttpConfig, CbreHttpConfigToken } from './cbre-http.config';
import { HttpMethods } from './services/http-methods.service';
import { HttpStreamsService } from './services/http-streams.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
})
export class CbreHttpModule {
  static forRoot(options: CbreHttpConfig): ModuleWithProviders<CbreHttpModule> {
    return {
      ngModule: CbreHttpModule,
      providers: [
        { provide: CbreHttpConfigToken, useValue: options },
        HttpMethods,
        HttpStreamsService,
      ],
    };
  }
}
